// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mg-0";